import { AlertDialog, Button } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

type ComposerMediaEditorDiscardDialogProps = Readonly<{
  open: boolean
  changedItemCount: number
  getReturnFocusTarget?: () => HTMLElement | null
  onOpenChange: (open: boolean) => void
  onDiscard: () => void
}>

export const ComposerMediaEditorDiscardDialog = ({
  open,
  changedItemCount,
  getReturnFocusTarget,
  onOpenChange,
  onDiscard,
}: ComposerMediaEditorDiscardDialogProps): JSX.Element => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialog.Content
      onCloseAutoFocus={(event): void => {
        const target = getReturnFocusTarget?.()
        if (!target?.isConnected) return

        event.preventDefault()
        target.focus()
      }}
    >
      <AlertDialog.Title>Discard changes?</AlertDialog.Title>
      <AlertDialog.Description>
        You’ll lose changes to {changedItemCount}{' '}
        {changedItemCount === 1 ? 'item' : 'items'}.
      </AlertDialog.Description>
      <AlertDialog.Actions>
        <AlertDialog.Cancel>
          <Button variant="tertiary">Keep Editing</Button>
        </AlertDialog.Cancel>
        <AlertDialog.Action>
          <Button variant="critical" onClick={onDiscard}>
            Discard Changes
          </Button>
        </AlertDialog.Action>
      </AlertDialog.Actions>
    </AlertDialog.Content>
  </AlertDialog>
)
